import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  TypeBlock,
  FeatureList,
  UsageSteps,
  VideoBlock,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';

const TunnelLimit = () => {
  

  const features = [
    {
      title: '긴급 상황 자동 대응 시스템',
      bullets: [
      {
        label: (
          <>화재 감지기, CCTV, 관제 센터 제어 시스템 등과 연동하여 위험 발생 시 자동으로 차단기가 내려가 차량 진입을 즉시 통제함</>
        ),
      },
      ]
    },
    {
      title: '높은 시인성과 신뢰성',
      bullets: [
      {
        label: (
          <>LED 경고등, 표지판, 차단부의 조명 시스템을 통해 운전자에게 명확한 차단 신호를 제공하여 안전성을 높임</>
        ),
      },
      ]
    },
    {
      title: '신속한 수동 조작 가능',
      bullets: [
      {
        label: (
          <>비상상황에서 자동 제어가 어려운 경우를 대비해, 현장에서 즉각적으로 조작할 수 있는 수동 제어 기능을 제공</>
        ),
      },
      ]
    },
    {
      title: '다양한 설치 환경 대응',
      bullets: [
      {
        label: (
          <>단일 터널, 양방향 터널, 대형 장대터널 등 다양한 구조와 운영 시스템에 맞춰 커스터마이징이 가능함</>
        ),
      },
      ]
    },
  ];

  

  return (
    <>
      <HeroSection
        title={`터널진입 차단시설`}
        subtitle={`터널 내 긴급 상황 발생 시 2차 사고를 예방합니다`}
        backgroundImage="/images/products/guardrail/tunnel-limit2.jpg"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '터널진입 차단시설' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`2차 사고를 예방하는 핵심 안전장치`}
        title={`터널진입 차단시설`}
        description={
          <>
            터널 내부에서 화재나 교통사고 등 긴급 상황이 발생했을 때, 추가 차량의 진입을 신속하게 차단하여 {' '}
            2차 사고를 예방하는 핵심 안전장치입니다.
            <br />
            <br />
            자동 제어 시스템과 연동해 즉각적으로 작동하며, 터널 내 인명 보호와 재산 피해 최소화에 중요한 역할을 수행합니다.
          </>
        }
        images={[
          '/images/products/guardrail/tunnel-limit2.jpg',
          '/images/products/guardrail/tunnel-limit3.jpg',
        ]}
      />

      <SectionDivider />


      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="guardrail"
        currentPath="/products/guardrail/tunnel-limit"
        listPath="/products/guardrail"
      />


      <CTASection />
    </>
  );
};

export default TunnelLimit;
